import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  LOGOUT,
} from "./ActionTypes";

const initialState = {
  user: null,
  isLoading: false,
  error: null,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case REGISTER_REQUEST:
    case LOGIN_REQUEST:
    case UPDATE_PROFILE_REQUEST:
      return { ...state, isLoading: true, error: null };

    case REGISTER_SUCCESS:
      return { ...state, isLoading: false };

    case LOGIN_SUCCESS:
      return { ...state, isLoading: false, user: action.payload };

    case REGISTER_FAILURE:
    case LOGIN_FAILURE:
    case UPDATE_PROFILE_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case GET_USER_REQUEST:
      return { ...state, isLoading: true, error: null };

    case GET_USER_SUCCESS:
      return { ...state, isLoading: false, user: action.payload };

    case GET_USER_FAILURE:
      return { ...state, isLoading: false, error: action.payload };

    case UPDATE_PROFILE_SUCCESS:
      return { ...state, isLoading: false, user: action.payload };

    case LOGOUT:
      localStorage.removeItem("jwt");
      return { ...state, user: null, error: null };

    default:
      return state;
  }
};

export default authReducer;
